var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.81.781-6.485 15.474H8.093L4.902 3.907c-.196-.761-.363-1.038-.952-1.361C2.987 2.024 1.4 1.536 0 1.23L.098.78h6.81c.868 0 1.649.58 1.845 1.578l1.686 8.956L14.604.781h4.206Zm16.579 10.42c.018-4.082-5.649-4.304-5.608-6.13.011-.558.54-1.147 1.697-1.296.574-.077 2.155-.133 3.947.69l.703-3.28C35.163.835 33.924.5 32.384.5c-3.957 0-6.742 2.104-6.765 5.115-.026 2.227 1.987 3.47 3.505 4.211 1.56.759 2.08 1.243 2.075 1.924-.01 1.038-1.244 1.492-2.395 1.512-2.013.032-3.18-.543-4.113-.978l-.724 3.393c.934.429 2.663.801 4.453.823 4.204 0 6.955-2.082 6.968-5.3Zm10.447 5.054h3.703L46.308.781h-3.419c-.768 0-1.415.448-1.704 1.135l-6.003 14.34h4.202l.834-2.312h5.136l.482 2.311Zm-4.466-5.482 2.107-5.81 1.213 5.81h-3.32ZM24.53.78l-3.312 15.474h-4.003L20.527.781h4.003Z",
    fill: "#1A2ADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.8d839e646474b5005ea6d36e1c20efc8.svg";
export { ForwardRef as ReactComponent };